import {OEAsset, useClient, useDictionary} from '@adamlip/okeoke.client';
import {Button, Checkbox, Radio, RadioGroup, cn} from '@heroui/react';
import ModifierV4Type1 from 'components/_OrderElements/ModifierV4Type1';
import {useEffect, useState, useContext} from 'react';
import {AppParamsContext} from 'contexts/AppParamsContext';
import NumberFlow from '@number-flow/react';
import {Minus, Plus} from 'lucide-react';
import SendVibration from 'utils/Helpers-v1/SendVibration';
import ButtonListModfierSelector from 'components/Modals/OrderItemModalV3/ModifierSelectors/ButtonListModfierSelector';

function ModifierGroupSelector({group, firstInvalid, setModifierCount, tryedToAdd}) {
	const {getName} = useClient();
	const {appParams} = useContext(AppParamsContext);
	const {getValue} = useDictionary();
	const [selectedModifier, setSelectedModifier] = useState('');
	const [selectedModifiersCount, setSelectedModifiersCount] = useState(0);
	const [shakeIt, setShakeIt] = useState(false);
	useEffect(() => {
		let count = getSelectedCount();
		setSelectedModifiersCount(count);
		// eslint-disable-next-line
	}, [group]);

	useEffect(() => {
		if (group.type === 1) {
			for (let modifier of group.modifiers) {
				if (modifier.count === 1) setSelectedModifier(modifier.uuid);
			}
		}
	}, [group.type, group.modifiers]);

	const handelClickOnModifier = (params) => {
		SendVibration('light');

		if (group.type === 1) {
			setModifierCount(selectedModifier, 0);
			setModifierCount(params.modifierUUID, 1);
		}
		if (group.type === 2) {
			increaseCount(params);
		}
	};

	const increaseCount = (params) => {
		if (group.max !== 0 && selectedModifiersCount === group.max) return null;
		SendVibration('light');

		if (params.max !== 0) {
			params.max <= params.count ? setModifierCount(params.modifierUUID, params.max) : setModifierCount(params.modifierUUID, params.count + 1);
		} else setModifierCount(params.modifierUUID, parseInt(params.count || 0) + 1);
	};
	const decreaseCount = (params) => {
		//if(group.min !== 0 && selectedModifiersCount === group.min) return null
		SendVibration('light');

		if (params.min !== 0) {
			params.min >= params.count ? setModifierCount(params.modifierUUID, params.min) : setModifierCount(params.modifierUUID, params.count - 1);
		} else {
			setModifierCount(params.modifierUUID, parseInt(params.count || 1) - 1);
			if (params?.min > 0) {
				setShakeIt(true);
				setTimeout(() => {
					setShakeIt(false);
				}, 500);
			}
		}
	};

	const getSelectedCount = () => {
		let selectedCount = 0;

		for (let i = 0; i < group.modifiers.length; i++) {
			selectedCount += group.modifiers[i].count != null ? group.modifiers[i].count : 0;
		}
		return selectedCount;
	};
	if (!group?.availability?.visible) return null;

	if (group?.attributes?.className?.includes('type1'))
		return (
			<>
				<ModifierV4Type1 group={group} setCount={setModifierCount} />
			</>
		);
	if (group?.type === 2 && group?.attributes?.className === 'buttonList') {
		return <ButtonListModfierSelector getSelectedCount={getSelectedCount} group={group} decreaseCount={decreaseCount} increaseCount={increaseCount} handelClickOnModifier={handelClickOnModifier} />;
	}
	if (group?.type === 1) {
		return (
			<div className={`p-2 rounded-general border border-border flex flex-col gap-2 ${group?.valid === true ? 'border border-border' : 'border-2 border-primary'}`}>
				<div className='flex flex-row gap-1 items-start justify-between w-full'>
					<div className='flex flex-col gap-0 items-start justify-start grow'>
						<div className='text-lg font-bold'>{getName(group.name)}</div>
						{getName(group.description) !== '' && <div className='text-xs font-light opacity-60 bottom-[3px] relative'>{getName(group.description)}</div>}
					</div>

					{group?.min > 0 && (
						<div className='text-sm font-normal text-primary pt-[5px]'>
							*{getValue('app_modifierGroupDesc_v1_min_part1')} {group.min} {getValue('app_modifierGroupDesc_v1_min_part2')}
						</div>
					)}
				</div>
				<div className=''>
					<RadioGroup
						value={selectedModifier}
						className='w-full'
						onValueChange={(value) => {
							let modifier = group?.modifiers?.find((mod) => mod.uuid === value);
							handelClickOnModifier({
								modifierUUID: modifier.uuid,
								count: modifier.count,
							});
						}}
						classNames={{
							wrapper: 'w-full',
						}}>
						{group?.modifiers
							?.filter((modifier) => modifier?.availability?.visible === 1)
							?.map((modifier) => {
								return (
									<Radio
										classNames={{
											label: 'w-full ',
											base: 'flex-row-reverse gap-2',
											labelWrapper: 'w-full',
										}}
										className={`w-full max-w-full`}
										color='primary'
										key={modifier?.uuid}
										value={modifier?.uuid}>
										<div className='flex flex-col gap-0 items-start justify-start w-full py-1'>
											<div className='flex flex-row gap-2 items-center justify-between w-full'>
												<div>{getName(modifier?.name)}</div>
												{modifier.price > 0 && <div>+{parseInt(modifier.price)} Ft</div>}
											</div>
											<div className='text-sm opacity-60 italic'>{getName(modifier?.description)}</div>
										</div>
									</Radio>
								);
							})}
					</RadioGroup>
				</div>
			</div>
		);
	} else {
		return (
			<div className={`p-2 rounded-general   flex flex-col gap-2 ${group?.valid === true ? 'border border-border' : 'border-2 border-primary'}`} id={group?.uuid} name={group?.uuid}>
				<div className='flex flex-row gap-1 items-start justify-between w-full'>
					<div className='flex flex-col gap-0 items-start justify-start grow'>
						<div className='text-lg font-bold'>{getName(group.name)}</div>
						{getName(group.description) !== '' && <div className='text-xs font-light opacity-60 bottom-[3px] relative'>{getName(group.description)}</div>}
					</div>

					{group?.min > 0 && (
						<div className='text-sm font-normal text-primary pt-[5px] text-right'>
							{getValue('app_modifierGroupDesc_v1_min_part1')} {group.min} {getValue('app_modifierGroupDesc_v1_min_part2')}
						</div>
					)}
				</div>

				{group.type === 2 && (
					<div className='flex flex-col gap-0'>
						{group.min !== 0 && selectedModifiersCount < group.min && (
							<div className='text-sm text-primary font-medium flex flex-row gap-1 items-center justify-start'>
								<span>{getValue('app_modifierGroupDesc_v1_part1')}</span>
								<NumberFlow value={(+group.min || 0) - (+selectedModifiersCount || 0)} />
								<span>{getValue('app_modifierGroupDesc_v1_part2')}</span>
							</div>
						)}
						{/* {group.min !== 0 && group.max !== 0 && selectedModifiersCount >= group.min && selectedModifiersCount < group.max && (
							<div className='text-sm text-primary font-medium flex flex-row gap-1 items-center justify-start'>
								<span>{getValue('app_modifierGroupDesc_v2_part1')}</span>
								{group.max < 11 ? <NumberFlow value={group.max - selectedModifiersCount} /> : ''}
								<span>{getValue('app_modifierGroupDesc_v2_part2')}</span>
							</div>
						)} */}
						{group?.max !== 0 && selectedModifiersCount !== group?.max && (
							<div className='text-sm text-primary font-medium'>
								{`${getValue('app_modifiers_youCanSelectMore_v1')} `}
								<NumberFlow value={group.max - selectedModifiersCount} />
								{`${getValue('app_modifiers_youCanSelectMore_v2')} `}
							</div>
						)}
						{group.max !== 0 && selectedModifiersCount === group.max && <div className='text-sm text-primary font-medium'>{`${getValue('app_modifierGroupDesc_v3')}`}</div>}
					</div>
				)}
				<div className='flex flex-col gap-2 w-full'>
					{group.modifiers
						?.filter((modifier) => modifier?.availability?.visible === 1)
						?.map((modifier) => {
							if (modifier?.max === 1) {
								return (
									<Checkbox
										key={modifier?.uuid}
										aria-label={modifier?.uuid}
										classNames={{
											base: cn('flex w-full max-w-none bg-content1 m-0 flex-row-reverse	', 'items-center justify-start', 'cursor-pointer rounded-general gap-2 p-4 border-2 border-border', 'data-[selected=true]:border-primary'),
											label: 'w-full',
											wrapper: 'border-2 border-primary',
										}}
										radius={appParams?.styles?.borderRadius?.general === '0px' ? 'none' : ''}
										isSelected={modifier?.count > 0}
										isDisabled={group?.max !== 0 && selectedModifiersCount === group.max && modifier?.count === 0}
										onValueChange={(value) => {
											if (value === true) {
												increaseCount({
													modifierUUID: modifier.uuid,
													count: modifier.count,
													min: modifier.min,
													max: modifier.max,
												});
											} else {
												decreaseCount({
													modifierUUID: modifier.uuid,
													count: modifier.count,
													min: modifier.min,
													max: modifier.max,
												});
											}
										}}>
										<div className='flex flex-row gap-2 justify-between'>
											<div className={`orderItemModifierGroup-modifier-name  ${appParams?.styles?.fonts?.capitalize ? 'font-bold !uppercase' : ''}`}>{getName(modifier.name)}</div>
											<div className={`orderItemModifierGroup-modifier-price  ${appParams?.styles?.fonts?.capitalize ? 'font-bold !uppercase' : ''}`}>+{parseInt(modifier.price)} Ft</div>
										</div>
									</Checkbox>
								);
							}
							return (
								<div key={modifier.uuid} className={`flex flex-row items-center justify-between overflow-hidden  `}>
									<div className='flex flex-row gap-2 items-center grow '>
										{modifier.attributes?.appImage != null && <OEAsset uuid={modifier.attributes?.appImage} size='l' addClass='w-full h-full object-cover' addContainerClass={'w-[44px] h-[44px] shrink-0 rounded-general overflow-hidden'} />}
										<div className='flex flex-col gap-0 items-start grow '>
											<div className={`w-full text-left `}>{getName(modifier.name)}</div>
											<div className='text-xs opacity-90'>+{parseInt(modifier.price)} Ft</div>
											{modifier?.max !== 0 && modifier?.count !== modifier?.max && (
												<div className='text-xs opacity-70'>
													{`${getValue('app_modifiers_youCanSelectMore_v1')} `}
													<NumberFlow value={modifier.max - modifier?.count} />
													{`${getValue('app_modifiers_youCanSelectMore_v2')} `}
												</div>
											)}
										</div>
									</div>

									{group.type === 2 && (
										<>
											<div className='flex justify-end items-end ml-2'>
												{modifier?.max === 1 ? (
													<></>
												) : (
													<>
														<div className='flex flex-row gap-2 w-auto items-center p-1 bg-secondaryBackground rounded-full'>
															<Button
																color='primary'
																radius='full'
																variant='solid'
																isDisabled={modifier?.count === 0 || modifier?.count === modifier?.min}
																isIconOnly
																size='sm'
																onPress={() => {
																	decreaseCount({
																		modifierUUID: modifier.uuid,
																		count: modifier.count,
																		min: modifier.min,
																		max: modifier.max,
																	});
																}}>
																<Minus />
															</Button>
															<div className='min-w-[10px] flex items-center justify-center'>
																<NumberFlow className='w-full text-center' value={+modifier?.count || 0} />
															</div>
															<Button
																size='sm'
																radius='full'
																color='primary'
																variant='solid'
																isIconOnly
																isDisabled={modifier?.count === (modifier?.max === 0 ? 9999999 : modifier?.max) || (group.max !== 0 && selectedModifiersCount === (group.max === 0 ? 999999999 : group.max))}
																onPress={() => {
																	increaseCount({
																		modifierUUID: modifier.uuid,
																		count: modifier.count,
																		min: modifier.min,
																		max: modifier.max,
																	});
																}}>
																<Plus />
															</Button>
														</div>
													</>
												)}
											</div>
										</>
									)}
								</div>
							);
						})}
				</div>
			</div>
		);
	}
}

export default ModifierGroupSelector;
